import styled from "styled-components";
import { Button } from "reactstrap";


export const FormWrap = styled.div`
    label{
        display: block;
        text-align: left;
        margin-bottom: .5rem;
        font-weight: 300;
        font-style: normal;
        color: rgba(74, 74, 74, 1.00);
        font-size: 1rem;
    }
    .zip_Code{
        border-radius:0px;
        background-color: #fff;
        border:none;
        width:100%;
        border-radius:4px;
        height: calc(1.5em + .75rem + 2px);
        padding: 0px 10px;
        &:focus{
            outline:none;
        }
    }
    select{
        border-radius: 0px;
        background-color: #fff;
        width: 100%;
        color: #495057;
        border: none;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    .distance-select__control{
        outline:none !important;
        border:none !important;
        // border-color: hsl(0,0%,70%) !important;
        box-shadow: unset !important;
    }
`;

export const SearchButton = styled.button`
    padding: .75rem 2.85rem;
    background: rgba(255, 255, 255, 1.00);
    border: 1px solid rgba(234, 237, 240, 1);
    box-shadow: 0 6px 12px 0 rgba(221, 181, 187, 0.35);
    transition: all 400ms cubic-bezier(0.445, 0.5, 0.55, 0.95);
    color: rgba(164, 164, 164, 1.00);
    font-size: 1rem;
    line-height: 1.5;
    font-weight: 400;
    border-radius: 50rem;
    width: 100%;
    margin-top: 1.5rem;
    &:hover{
        box-shadow: 0 15px 12px 0 rgba(221, 181, 187, 0.35) !important;
        background: rgba(255, 255, 255, 1.00) !important;
        color: rgba(164, 164, 164, 1.00) !important;
        border: 1px solid rgba(234, 237, 240, 1) !important;
    }
    &:focus{
        outline:none;
    }
    @media only screen and (max-width:767px){
        margin-top: 1rem;
    }
`;

export const FindButton = styled.button`
    background: transparent;
    border: 1px solid rgba(0,0,0,.1);
    transition: all 400ms cubic-bezier(0.445,0.5,0.55,0.95);
    padding: .75rem 2.85rem;
    border-radius: 50rem!important;
    font-size: 1rem;
    color: rgba(0,0,0,.5) !important;
    line-height: 1.5;
    width: 100%;
    margin-top: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
        border: 1px solid #8cc63f !important;
        text-decoration: none;
        color: #8cc63f !important;
    }
    svg{
        color: #8cc63f !important;
        margin-right:.5rem;
        font-size:14px;
    }
    @media only screen and (max-width:767px){
        margin-top: 1rem;
    }
`;



// WEBPACK FOOTER //
// ./src/component/Locatedoctor/styles.js